// extracted by mini-css-extract-plugin
export var bodyContainer = "modalregistration-module--body-container--f14aa";
export var errorText = "modalregistration-module--error-text--78370";